import { FunctionCollection } from "./FunctionCollection";

export type Command<
  Functions extends FunctionCollection,
  Key extends keyof Functions = keyof Functions
> = {
  methodName: Key;
  arg: Parameters<Functions[Key]>[0];
};

export const Command = {
  isCommand<Api extends FunctionCollection>(
    x: any,
    api: Api
  ): x is Command<Api> {
    return (
      x &&
      typeof x === "object" &&
      "methodName" in x &&
      Object.keys(api).includes(x.methodName)
    );
  },
  builder<Functions extends FunctionCollection>(functionCollection: Functions) {
    type LocalKey = keyof typeof functionCollection;
    type LocalFunctionCollection = typeof functionCollection;

    const fct =
      <
        Key extends LocalKey,
        Arg extends Parameters<LocalFunctionCollection[Key]>[0]
      >(
        key: Key
      ) =>
      (arg: Arg): Command<LocalFunctionCollection, Key> => {
        return {
          methodName: key,
          arg,
        };
      };
    return fct;
  },
  call<MethodObject extends FunctionCollection, Key extends keyof MethodObject>(
    methodObject: MethodObject,
    { arg, methodName }: Command<MethodObject, Key>
  ): ReturnType<MethodObject[Key]> {
    return methodObject[methodName](arg);
  },
};
